import React from 'react'

import Accordion from '../../../components/accordion/Accordion'
import Footnote from '../../../components/footnote/Footnote'
import useStyles from '../Remittances.styles'

export default function RemittancesAccordion () {
  const classes = useStyles()

  return (
    <>
      <div className={classes.accordionContainer}>
        <div className={classes.accordionCaptionContainer}>
          <h2 className={classes.accordionTitle}>A Trusted Solution</h2>
          <div className='slide-img-text d-flex pb-3' style={{ fontSize: 20 }}>
            Whether it's supporting family back home or helping out with unexpected expenses, our
            service makes it easier to stay connected financially.
          </div>
        </div>
        <div className={classes.accordionEmployersContainer}>
          <div className='pb-5 mb-5'>
            <Accordion content={accordion} />
          </div>
          <Footnote
            notes={[
              'Subject to Terms & Conditions.',
              'Central Bank of Kansas City does not administer nor is liable for remittance transfers. Remittance services are provided by Ria Money Transfer. Terms and conditions apply.'
            ]}
            omitPadding
          />
        </div>
      </div>
    </>
  )
}

const accordion = [
  {
    title: 'Global Reach',
    textLine1: 'Send money to more than 190 countries and territories.'
  },
  {
    title: 'Flexible Options',
    textLine1: 'Choose cash pickup, bank deposit, or mobile wallet transfers.'
  },
  {
    title: 'Quick Transfers Available',
    textLine1:
      'Send money in minutes, so funds are available quickly when your loved ones need it most.'
  },
  {
    title: 'Secure Tool',
    textLine1:
      'RIA Money Transfer is one of the world’s leading remittance providers and trusted by millions.'
  },
  {
    title: 'Transparent Fees and Competitive Rates',
    textLine1: 'Enjoy great rates with no hidden fees, ensuring your support goes further.'
  }
]
